// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__365x4","inner":"Form_inner__2PfNd","range":"Form_range___iLqB","name":"Form_name__8ZLZ9","actions":"Form_actions__3epdN"};